import { Quote } from "lucide-react";
import carterPhoto from "@/assets/carter-berney.jpg";

const stats = [
  { value: "$100M+", label: "Revenue Managed" },
  { value: "1,000+", label: "Reps Onboarded" },
  { value: "6+", label: "Industries Served" },
];

export default function StatsSection() {
  return (
    <section id="results" className="py-28 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold">Numbers Don't Lie.</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-px rounded-xl border bg-border overflow-hidden mb-20">
          {stats.map((s) => (
            <div key={s.label} className="bg-card p-10 text-center">
              <p className="text-4xl md:text-5xl font-bold text-[#3b82f6] tabular-nums">
                {s.value}
              </p>
              <p className="text-sm text-muted-foreground mt-2 uppercase tracking-wide">
                {s.label}
              </p>
            </div>
          ))}
        </div>

        {/* Testimonial with photo */}
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-5 gap-8 items-center">
            <div className="md:col-span-2 flex justify-center">
              <img
                src={carterPhoto}
                alt="Carter Berney"
                className="w-72 h-72 md:w-80 md:h-80 rounded-2xl object-cover object-bottom border shadow-lg"
              />
            </div>
            <div className="md:col-span-3">
              <Quote className="h-8 w-8 text-[#3b82f6]/30 mb-4" />
              <p className="text-lg md:text-xl italic text-muted-foreground leading-relaxed mb-6">
                "We built AMPA because we lived it. Managing a growing sales team
                with spreadsheets and 5 different apps is broken. AMPA is the one
                AI-powered platform I wish I had from day one."
              </p>
              <div>
                <p className="font-semibold text-lg">Carter Berney</p>
                <p className="text-sm text-muted-foreground">
                  Founder, AMPA Network
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
